import { useWatch, useFormContext } from "react-hook-form";
import useIntakeFormStore from "../../../store/IntakeForm.store";

import Disclosures from "../../Disclosures";
const IntakeFormDisclosure = () => {
  const { control } = useFormContext();
  const categoryValue = useWatch({
    control,
    name: "selectCategory",
  });
  const strategy = useWatch({
    control,
    name: "selectStrategy",
  });

  const [formOptions] = useIntakeFormStore((state) => [state.data.formOptions]);
  const assetClass = formOptions.strategyDetails.find(
    (strat) => strat.sector === categoryValue && strat.strategyCode === strategy
  )?.assetClass;

  const marketingCommunication = "Marketing Communication";

  const fixedIncomeDisclosureArgs = {
    className: "disclosures--proposal",
    bodyContent: [
      {
        heading: marketingCommunication,
        content: (
          <ul>
            <li>Not Insured by the FDIC or Any Federal Government Agency</li>
            <li>
              Not a Deposit or Other Obligation of, or Guaranteed by, the Bank
              or Any Bank Affiliate
            </li>
            <li>
              Subject to Investments Risks, Including Possible Loss of the
              Principal Amount Invested
            </li>
            <li>For Investment Professional Use Only</li>
          </ul>
        ),
      },
      {
        heading: "",
        content: (
          <>
            <p>
              Investments in fixed-income securities are subject to market,
              interest rate, credit and other risks. Bond prices fluctuate
              inversely to changes in interest rates. Therefore, a general rise
              in interest rates can result in the decline in the bond’s price.
              Credit risk is the risk that an issuer will default on payments of
              interest and/or principal. This risk is heightened in lower rated
              bonds. If sold prior to maturity, fixed income securities are
              subject to market risk. All fixed income investments may be worth
              less than their original cost upon redemption or maturity.
            </p>
            <p>
              This material has been prepared by Allspring Global Investments,
              LLC, a registered Investment Advisor, and the material is intended
              for use by investment professionals with their clients. This
              material is for general informational and educational purposes
              only and is NOT intended to provide investment advice or a
              recommendation of any kind — including a recommendation for any
              specific investment, strategy, or plan.
            </p>
            <p>
              Allspring Global InvestmentsTM is the trade name for the asset
              management firms of Allspring Global Investments Holdings, LLC, a
              holding company indirectly owned by certain private funds of GTCR
              LLC and Reverence Capital Partners, L.P. These firms include but
              are not limited to Allspring Global Investments, LLC, and
              Allspring Funds Management, LLC. Certain products managed by
              Allspring entities are distributed by Allspring Funds Distributor,
              LLC (a broker-dealer and Member FINRA/SIPC).
            </p>
          </>
        ),
      },
    ],
    isReportPage: false,
  };

  const equitiesDisclosureArgs = {
    className: "disclosures--proposal",
    bodyContent: [
      {
        heading: marketingCommunication,
        content: (
          <ul>
            <li>Not Insured by the FDIC or Any Federal Government Agency</li>
            <li>
              Not a Deposit or Other Obligation of, or Guaranteed by, the Bank
              or Any Bank Affiliate
            </li>
            <li>
              Subject to Investments Risks, Including Possible Loss of the
              Principal Amount Invested
            </li>
            <li>For Investment Professional Use Only</li>
          </ul>
        ),
      },
      {
        heading: "",
        content: (
          <>
            <p>
              This material has been prepared by Allspring Global Investments,
              LLC, a registered Investment Advisor, and the material is intended
              for use by investment professionals with their clients. This
              material is for general informational and educational purposes
              only and is NOT intended to provide investment advice or a
              recommendation of any kind — including a recommendation for any
              specific investment, strategy, or plan.
            </p>
            <p>
              Allspring Global InvestmentsTM is the trade name for the asset
              management firms of Allspring Global Investments Holdings, LLC, a
              holding company indirectly owned by certain private funds of GTCR
              LLC and Reverence Capital Partners, L.P. These firms include but
              are not limited to Allspring Global Investments, LLC, and
              Allspring Funds Management, LLC. Certain products managed by
              Allspring entities are distributed by Allspring Funds Distributor,
              LLC (a broker-dealer and Member FINRA/SIPC).
            </p>
          </>
        ),
      },
    ],
    isReportPage: false,
  };

  return assetClass === "Equity" ? (
    <Disclosures {...equitiesDisclosureArgs} />
  ) : (
    <Disclosures {...fixedIncomeDisclosureArgs} />
  );
};

export default IntakeFormDisclosure;
